export default __webpack_public_path__ + "static/media/powerSupply1.44b6c347.svg";